import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_PAGE_DYNAMIC_PRICING_EXPERIMENT = defineFcm('promote_page_dynamic_pricing_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
				category_tiers: {
					type: 'object',
					shape: {
						premium: {
							type: 'object',
							shape: {
								multiplier: { type: 'number' },
								tags: { type: 'array', shape: { type: 'string' } },
							},
						},
						discount: {
							type: 'object',
							shape: {
								multiplier: { type: 'number' },
								tags: { type: 'array', shape: { type: 'string' } },
							},
						},
					},
				},
				state_tiers: {
					type: 'object',
					shape: {
						premium: {
							type: 'object',
							shape: {
								multiplier: { type: 'number' },
								states: { type: 'array', shape: { type: 'string' } },
							},
						},
						discount: {
							type: 'object',
							shape: {
								multiplier: { type: 'number' },
								states: { type: 'array', shape: { type: 'string' } },
							},
						},
					},
				},
				exclusion_group_experiment_id: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Promote Page',
		description:
			'Controls the promote page dynamic pricing experiment: the category and state tier tables (with their multipliers) used to scale the ask ladder, and the dynamic experiment name. exclusion_group_experiment_id is the member id to check this experiment against in FCM_PROMOTE_PAGE_EXCLUSION_GROUP; leave unset to run unconditionally, bypassing the exclusion group entirely.',
		template: {
			experiment_name: 'promote_page_dynamic_pricing_experiment',
			exclusion_group_experiment_id: 'promote_page_dynamic_pricing_experiment',
			category_tiers: {
				premium: {
					multiplier: 1.25,
					tags: [
						'national government',
						'due process',
						'public health',
						'land use & zoning',
						'local government',
						'wildlife & biodiversity',
						'immigration policy',
						'drug & medicine regulation',
					],
				},
				discount: {
					multiplier: 0.8,
					tags: [
						'consumer rights',
						'video games & online gaming',
						'technology regulation',
						'animal welfare',
						"workers' rights",
						'student issues',
						'cultural preservation',
						'data privacy',
					],
				},
			},
			state_tiers: {
				premium: {
					multiplier: 1.15,
					states: ['VT', 'NH', 'ME', 'HI', 'CO', 'SC', 'NY', 'MS', 'ND', 'CA', 'MD', 'AK'],
				},
				discount: {
					multiplier: 0.9,
					states: ['SD', 'TN', 'KS', 'MO', 'LA', 'MN', 'WV', 'WI', 'WY', 'MI', 'KY', 'IN', 'OH'],
				},
			},
		},
	});
